import { ADD_BANKDETAILS, ADD_BANKDETAILS_FAILED, ADD_BANKDETAILS_SUCCESS, BANKDETAILS, BANKDETAILS_FAILED, BANKDETAILS_SUCCESS, UPDATE_BANKDETAILS, UPDATE_BANKDETAILS_FAILED, UPDATE_BANKDETAILS_SUCCESS } from "./actionTypes"

let initialState = {
    bankdetails: [],
    addBankdetails: "",
    updateBankdetails: "",
    loading: false,
    success: false,
    error: ''
}

export const bankdetailsReducer = (state = initialState, action) => {
    switch (action.type) {

        case BANKDETAILS: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case BANKDETAILS_SUCCESS: return {
            ...state,
            bankdetails: action.payload,
            loading: false,
            success: true
        }
        case BANKDETAILS_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_BANKDETAILS: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_BANKDETAILS_SUCCESS: return {
            ...state,
            addBankdetails: action.payload,
            bankdetails: [...state.bankdetails, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_BANKDETAILS_FAILED: return {
            ...state,
            addBankdetails: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATE_BANKDETAILS: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATE_BANKDETAILS_SUCCESS: return {
            ...state,
            updateBankdetails: action.payload,
            bankdetails: state.bankdetails.map((item) => item.id === action.payload.id ? action.payload : item),
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_BANKDETAILS_FAILED: return {
            ...state,
            updateBankdetails: [],
            loading: false,
            success: false,
            error: action.payload
        }

        default: return state
    }
}